if ('NodeList' in window && !NodeList.prototype.forEach) {
    console.info('polyfill for IE11');
    NodeList.prototype.forEach = function (callback, thisArg) {
        thisArg = thisArg || window;
        for (let i = 0; i < this.length; i++) {
            callback.call(thisArg, this[i], i, this);
        }
    };
}

function showDatepicker(checkIn, checkOut) {
    //Properties Day's Calendar [Enable/Disable,ClassName,Tooltip]
    let DATE_STYLE = [true];
    function calendarRange(date) {
        let d1 = $.datepicker.parseDate(DATE_FORMAT, $(checkIn).val());
        let d2 = $.datepicker.parseDate(DATE_FORMAT, $(checkOut).val());
        if (d1 && date.getTime() == d1.getTime() || d2 && date.getTime() == d2.getTime()) {
            DATE_STYLE[1] = 'highlight-top';
        } else if (date > d1 && date < d2) {
            DATE_STYLE[1] = 'highlight';
        } else {
            DATE_STYLE[1] = '';
        }
        return DATE_STYLE;
    }

    //Check in and check out datepicker for booking engine
    const DATE_FORMAT = ($(checkIn).data("format") !== undefined && $(checkIn).data("format")) ? $(checkIn).data("format") : "mm-dd-yy";
    $(checkIn).datepicker({
        //showOn: "both",
        //buttonImage: SITE_FILES+"images/img-calendar-gray.png",
        //buttonImageOnly: true,
        changeMonth: true,
        dateFormat: DATE_FORMAT,
        numberOfMonths: 1,
        minDate: 0,
        beforeShowDay: (date) => calendarRange(date),
        onSelect: function (selectedDate) {
            let getDate = $(this).datepicker('getDate');
            let newDate = new Date(getDate.getTime());
            newDate.setDate(newDate.getDate() + 3);
            $(checkOut).datepicker("setDate", newDate);
            $(checkOut).datepicker("option", "minDate", selectedDate);
        }
    });
    $(checkOut).datepicker({
        //showOn: "both",
        //buttonImage: SITE_FILES+"images/img-calendar-gray.png",
        //buttonImageOnly: true,
        dateFormat: DATE_FORMAT,
        changeMonth: true,
        numberOfMonths: 1,
        beforeShowDay: (date) => calendarRange(date),
        onSelect: function (selectedDate) {
            //$( "#CheckIn" ).datepicker( "option", "maxDate", selectedDate );
        }
    });
}


(function () {
    $(".topalert__cta").fancybox();

    /*
        HOME ARROW
        $('.arrow-home').click(function(event) {
            $('body, html').animate({
                scrollTop: $(window).height()-$('header').outerHeight()*2},
                800, 'easeOutExpo');
        });
    */

    $('.content-spot').click(function (e) {
        document.getElementById('name_room').value = this.dataset.title;
        console.log(this.dataset.title)
    })

    $(".content-spot, .open-save-spot").fancybox({
        openEffect: 'none',
        closeEffect: 'none',
        afterShow: function () {
            showDatepicker('#check_in_safe_spot', '#check_out_safe_spot');
        }
    });

    // Remove empty <p> tags created by tinymce
    const paragraph = document.querySelectorAll('p') || [];
    paragraph.forEach(e => (e.innerHTML.trim() === '') && e.parentNode.removeChild(e));


    $('.sym-slides').slick();
    
    $('.fancybox').fancybox();

    $(".intro-video-lbx1").fancybox({
        afterClose: function() {
            let video = $("#video-intro video")[0];
            if (video) {
                video.pause();
            }
        },
        afterShow: function () {
            let video = $("#video-intro video")[0];
            if (video) {
                video.play();
            }
        }
    });

    $(".intro-video-lbx2").fancybox({
        afterClose: function() {
            let video = $("#video-intro2 video")[0];
            if (video) {
                video.pause();
            }
        },
        afterShow: function () {
            let video = $("#video-intro2 video")[0];
            if (video) {
                video.play();
            }
        }
    });

    $(".single-quad__video-fancybox").fancybox({
        afterClose: function() {
            let video = $("#single-quad__video video")[0];
            if (video) {
                video.pause();
            }
        },
        afterShow: function () {
            let video = $("#single-quad__video video")[0];
            if (video) {
                video.play();
            }
        }
    });

    $('.cover-video').click(function () {
        $(this).fadeOut(270);
        $('.video-content')[0].play();
    });

    var videoUrl;
    $('.open-video').click(function (event) {
        event.preventDefault();
        videoUrl = $(this).attr('data-video');

    })
    $('.open-video').fancybox({
        afterShow: function () {
            $('#lightbox-video').attr('src', videoUrl);
            $('#lightbox-video')[0].play();
        },
        overlayShow: true,
        centerOnScroll: true,
        speedIn: 100,
        speedOut: 50,
        allowfullscreen: true,
        width: '100%',
        height: '100%',
        autosize: false
    });

    $(".toggle-tabs li").click(function () {
        $(this).addClass('active-tab').parents('ul.toggle-tabs').find('li').not($(this)).removeClass('active-tab');
        var currentTabIndex = $(this).index();
        $('.content-box:eq(' + currentTabIndex + ')').addClass('active-content-box').parents('.tabbed-content-wrap').find('.content-box').not($('.content-box:eq(' + currentTabIndex + ')')).removeClass('active-content-box');
    });

})();